/**
 * Path helper for the Bibliography Studio, which renders its own application
 * chrome instead of the site header and footer. Catalog-free so the layout wrapper
 * can import it without pulling anything heavy into the client bundle.
 */

const STUDIO_PATH = /^\/[a-z]{2}\/bibliography\/?$/;

/** `/en/bibliography` (any locale), never the shared-bibliography viewer. */
export function isBibliographyStudioPath(pathname: string): boolean {
  return STUDIO_PATH.test(pathname);
}
